const API_PREFIX = '/roles';


export const getGetRoleByEndpoint = () =>
    `${API_PREFIX}/`;